/* Copyright Information: Created by BuyGroup */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { getCategory } from "../../../actions/category";
import "./NavbarHorizontal.css";

const NavbarHorizontal = ({ getCategory: fetchCategory }) => {
  const [menuItemList, setMenuItemList] = useState([]);

  useEffect(() => {
    fetchCategory(buildMenuFromCategories);
  }, [fetchCategory]);

  const buildMenuFromCategories = (categoryData = []) => {
    const menuItems = [{ title: "Home", type: "sub", path: "/" }];
    const moreChildren = [];

    categoryData.forEach((category, index) => {
      const menuChildren = (category.sub_category || []).map((subCategory) => ({
        title: subCategory.category_name,
        type: "sub",
        path: `/category/${subCategory.category_id}`,
      }));

      const menuItem = {
        title: category.category_name,
        type: "sub",
        path: `/category/${category.category_id}`,
        children: menuChildren,
      };

      if (index < 3) {
        menuItems.push(menuItem);
      } else {
        moreChildren.push({
          title: category.category_name,
          type: "sub",
          path: `/category/${category.category_id}`,
          children: (category.sub_category || []).map((subCategory) => ({
            title: subCategory.category_name,
            type: "link",
            path: `/category/${subCategory.category_id}`,
          })),
        });
      }
    });

    if (moreChildren.length > 0) {
      menuItems.push({
        title: "More",
        type: "sub",
        children: moreChildren,
      });
    }

    setMenuItemList(menuItems);
  };

  return (
    <div className="main-navbar navbar-horizontal-only">
      <div id="mainnav">
        <ul className="nav-menu">
          {menuItemList.map((menuItem, i) => (
            <li
              key={`menuItemList${i}`}
              className={`${menuItem.megaMenu ? "mega-menu" : ""}`}
            >
              <Link
                to={menuItem.path || "#"}
                className={
                  menuItem.path === window.location.pathname
                    ? "disabled-link"
                    : "nav-link"
                }
              >
                {menuItem.title}
                {menuItem.children && menuItem.children.length > 0 && (
                  <span className="sub-arrow"></span>
                )}
              </Link>

              {menuItem.children && (
                <ul className="nav-submenu">
                  {menuItem.children.map((childrenItem, index) => (
                    <li
                      key={`menuItemChildren${index}`}
                      className={`${childrenItem.children ? "sub-menu" : ""}`}
                    >
                      {(childrenItem.type === "sub" ||
                        childrenItem.type === "link") && (
                        <Link to={childrenItem.path || "#"}>
                          {childrenItem.title}
                          {childrenItem.tag === "new" && (
                            <span className="new-tag">new</span>
                          )}
                          {childrenItem.children && (
                            <i className="fa fa-angle-right pl-2"></i>
                          )}
                        </Link>
                      )}

                      {childrenItem.children ? (
                        <ul
                          className={`nav-sub-childmenu ${
                            childrenItem.active ? "menu-open" : "active"
                          }`}
                        >
                          <div>
                            {childrenItem.children.map((childrenSubItem, key) => (
                              <li key={`childrenSubItem${key}`}>
                                {childrenSubItem.type === "link" && (
                                  <Link to={childrenSubItem.path || "#"}>
                                    {childrenSubItem.title}
                                    {childrenSubItem.tag === "new" && (
                                      <span className="new-tag">new</span>
                                    )}
                                  </Link>
                                )}
                              </li>
                            ))}
                          </div>
                        </ul>
                      ) : (
                        ""
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    category: state.category.category,
  };
};

const mapDispatchToProps = {
  getCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavbarHorizontal);
/* Copyright Information: Created by BuyGroup */
